const { showError, showNotifikasi } = require('../../libs/helper');
var qs = require('qs');

module.exports = {
    getDetail: (g, params) => {
        let result = g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/pendalaman/detail/register-b',
            method: 'post',
            data: qs.stringify(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            console.log(err)
        })
        return result;

    },
    getDataBmdHasilSensus: (g, params) => {
        const result = g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/pendalaman/validasi/list',
            method: 'post',
            data: qs.stringify(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        }).then(res => res.data).catch(err => {
            showError(g, err, 'Error Get Data')
        })
        return result
    },
    getDetailDataBmdHasilSensus: (g, params) => {
        const result = g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/pendalaman/detail/hasil-sensus',
            method: 'post',
            data: qs.stringify(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        }).then(res => res.data).catch(err => {
            showError(g, err, 'Error Get Data')
        })
        return result
    },
    validasiP3b: async (g, data) => {
        let result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/pendalaman/validasi/p3b',
            method: 'post',
            data: qs.stringify(data),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            return err;
        })
        return result;
    },
    pengembalianPua: async (g, data) => {
        let result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/pendalaman/pengembalian/pua',
            method: 'post',
            data: qs.stringify(data),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            return err;
        })
        return result;
    },
    submitHapusData: async (g, data) => {
        let result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/pendataan/blm-tercatat/delete',
            method: 'post',
            data: qs.stringify(data),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            return err;
        })
        return result;
    },
    
    getNrkSingleData: async (g, params) => {
        let payload = { ...params }
        payload.nrk = parseInt(payload.nrk);
        let result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/ref/get-nrk',
            method: 'post',
            data: qs.stringify(payload),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            showError(g, err, `Error Get Data`)
        })
        return result;
    },
    validasiKepala: async (g, data) => {
        let result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/pendalaman/validasi/ka',
            method: 'post',
            data: qs.stringify(data),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            return err;
        })
        return result;
    },

}